import { makeStyles } from '@mui/styles';

export const styles = makeStyles(() => ({
  grid: {
    display: 'block',
    whiteSpace: 'pre-wrap',
  },
}));
